import { useSyncExternalStore } from 'react';
import { MOBILE_MEDIA_QUERY } from '@/layouts/mobile-access';

function subscribe(onChange: () => void) {
  const query = window.matchMedia(MOBILE_MEDIA_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

export function useIsMobile() {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(MOBILE_MEDIA_QUERY).matches,
    () => false
  );
}
